// extracted by mini-css-extract-plugin
export default {"condensed":"styles__condensed--y5Ron","more-label":"styles__more-label--avoKa"};